import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Typography } from "./ui/typography";
import { FormField, FormItem, FormMessage, FormInput } from "./ui/form";
import StackFormLayout from "./ui/stack-form-layout";
import StackSelectionCard from "./ui/stack-selection-card";
import StackFormButtons from "./ui/stack-form-buttons";
import BalanceDisplay from "./ui/balance-display";
import {
  AutoStackFormData,
  AutoStackStepType as StepType,
} from "../pages/Autostack";
import stackIcon from "../assets/images/autostack/stack-header-icon.svg";
import { useQueryDigitalWallet } from "../hooks/query/queries";
import { formatCurrency } from "../utils/utils";

interface AutoStackStepProps {
  onStepComplete: () => void;
  onStepBack: () => void;
  onCancel: () => void;
  currentStep: StepType;
}

const AutoStackStep: React.FC<AutoStackStepProps> = ({
  onStepComplete,
  onCancel,
}) => {
  const form = useFormContext<AutoStackFormData>();

  const {
    digitalWalletData,
    isLoading: isLoadingDigitalWallet,
    // isFetching: isFetchingDigitalWallet,
  } = useQueryDigitalWallet();

  const [fiatBalance, setFiatBalance] = useState<number>(0);

  useEffect(() => {
    const newBalance =
      digitalWalletData?.balances?.assetBalances?.fiat?.[0]?.availableAmount;
    if (newBalance !== undefined && newBalance !== null) {
      setFiatBalance(newBalance);
    }
  }, [digitalWalletData]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    onStepComplete();
  };

  return (
    <StackFormLayout
      title="Create new AutoStack"
      onCancel={onCancel}
      showCancelHeader={true}
      headerIcon={stackIcon}
    >
      <form onSubmit={handleSubmit} className="space-y-6">
        <FormField
          control={form.control}
          name="stackName"
          render={({ field }) => (
            <FormItem>
              <Typography variant="label" className="block mb-3">
                Name your new AutoStack
              </Typography>
              <FormInput
                type="text"
                placeholder="e.g. My BTC Vault"
                className="h-14"
                maxLength={50}
                {...field}
              />
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="stackType"
          render={({ field }) => (
            <FormItem>
              <div className="flex flex-wrap md:flex-nowrap gap-4">
                <StackSelectionCard
                  isSelected={field.value === "wallet"}
                  onClick={() => field.onChange("wallet")}
                  title="Auto wallet stack"
                  description="Set up a frequent schedule for an asset from your wallet balance."
                  footer={
                    <BalanceDisplay
                      amount={formatCurrency(fiatBalance, "ZAR")}
                      isLoading={isLoadingDigitalWallet}
                      variant="default"
                    />
                  }
                />

                <StackSelectionCard
                  isSelected={field.value === "bank"}
                  onClick={() => field.onChange("bank")}
                  title="Bank transfer stack"
                  description="Set up recurring bank transfers that auto-trigger purchases."
                  disabled={true}
                />
              </div>
            </FormItem>
          )}
        />

        <StackFormButtons onBack={onCancel} isSubmitType={true} />
      </form>
    </StackFormLayout>
  );
};

export default AutoStackStep;
